import { getSessionId } from "./getSession.es.js";
import { deepEquals } from "../../../utils/deepEquals.es.js";
import { updateIdcsSession } from "../../services/idcs-service.es.js";
import { setMerkleDataTracker } from "../../../utils/merkleDataTracker.es.js";
import { userInsights, setUserInsights } from "../../../utils/userInsights.es.js";
import { fetchIds, setUserInsightIds, getUserInsightIds } from "../../../utils/userInsightData.es.js";
import { logger } from "../../../utils/logger.es.js";
import { getMerkleIds } from "../merkle/getMerkleIds.es.js";
import "../../../cookies-04bd2321.js";
import "../utils/getUtmParams.es.js";
import "./utils.es.js";
import "../../../utils/sharedServiceUrl.es.js";
import "../../../getTealiumIds-c24d3498.js";
import "../../../waitFor-1b67bbb8.js";
import "../visitId/visitId.es.js";
import "../../../cookieHandler-ac6954c1.js";
import "../visitId/adapter.es.js";
import "../timeOnPage/timeOnPage.es.js";
import "../../../v4-88c20f3b.js";
import "../visitId/constants.es.js";
import "../visitId/processUrlVisitId.es.js";
import "../visitId/utils.es.js";
let isGetUserInsightsRunning = false;
let pendingPromise = null;
const getUserInsightsData = async (sessionId, isFirstTime = false, insightIdsParam) => {
  const insightIds = insightIdsParam || await fetchIds();
  const userInsightsFormBody = {
    id: sessionId,
    visitId: insightIds.visit_id,
    previousVisitId: insightIds.previous_visit_id,
    tealiumVisitorID: insightIds.tealium_visitor_id,
    merkleConfidenceScore: insightIds.merkury_confidence_score != null ? Number(insightIds.merkury_confidence_score) : void 0,
    merkleCmid: insightIds.merkury_cmid,
    merkleHmid: insightIds.merkury_hmid
  };
  const userInsightData = await updateIdcsSession(sessionId, { ...userInsightsFormBody });
  setUserInsights({ fired: isFirstTime ? true : userInsights.fired, insights: userInsightData });
};
const getUserInsights = async () => {
  if (isGetUserInsightsRunning && pendingPromise) {
    return pendingPromise;
  }
  isGetUserInsightsRunning = true;
  pendingPromise = (async () => {
    try {
      const sessionId = await getSessionId();
      if (!sessionId) {
        logger.warn("No session id found");
        return userInsights.insights;
      }
      const merkleData = await getMerkleIds();
      if (!userInsights.fired && sessionId) {
        await getUserInsightsData(sessionId, true);
        setMerkleDataTracker(merkleData);
        const insightIds = await fetchIds();
        setUserInsightIds(insightIds);
        return userInsights.insights;
      }
      const latestUserIds = await fetchIds();
      const currentUserInsightIds = getUserInsightIds();
      const userInsightIdsAreSame = deepEquals(currentUserInsightIds, latestUserIds);
      if (sessionId && currentUserInsightIds && !userInsightIdsAreSame) {
        await getUserInsightsData(sessionId, false, latestUserIds);
        setUserInsightIds(latestUserIds);
        setMerkleDataTracker(merkleData);
        return userInsights.insights;
      }
      return userInsights.insights;
    } finally {
      isGetUserInsightsRunning = false;
      pendingPromise = null;
    }
  })();
  return pendingPromise;
};
export {
  getUserInsights
};
